import type { BodyRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type RequestMagicLinkRequestBody = {
  email: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Keys are defined by Backend API endpoint
  redirect_url?: string;
};

export const requestMagicLink = async ({ body }: BodyRequest<RequestMagicLinkRequestBody>) =>
  apiClient.post<undefined, ApiClientResponse<undefined>>(routes.oauth.magicLink, body, { skipAuth: true });
